/* Theme-local navigation; Shopify's native product and cart code handles commerce. */
document.addEventListener('click', (event) => {
  document.querySelectorAll('.al-mobile-menu[open], .al-mega[open]').forEach((menu) => {
    if (!menu.contains(event.target)) menu.removeAttribute('open');
  });
});
document.addEventListener('keydown', (event) => {
  if (event.key !== 'Escape') return;
  document.querySelectorAll('.al-mobile-menu[open], .al-mega[open]').forEach((menu) => {
    menu.removeAttribute('open');
    menu.querySelector('summary').focus();
  });
});


(() => {
  if (!/^\/(?:[a-z]{2}(?:-[a-z]{2})?\/)?apps\/bestrack\/?$/i.test(window.location.pathname)) return;
  const labels = JSON.parse(document.getElementById('al-runtime-i18n').textContent);
  const keys = {"Tracking Number":"tracking_number","Tracking number":"tracking_number","Order Number":"order_number","Order number":"order_number","Email":"email","Track Your Order":"track_order","Powered by BestTrack":"powered","Ready-to-go tracking query":"tracking_query","Tracking method":"tracking_method","Shipment progress":"shipment_progress","Delivery progress":"delivery_progress","Tracking:":"tracking","Ordered":"ordered","Order Ready":"order_ready","In Transit":"in_transit","In transit":"in_transit","Out for Delivery":"out_delivery","Delivered":"delivered","Est. Delivery":"estimated_delivery","Estimated time may update as tracking progresses.":"estimate_note","Shipping Details":"shipping_details","Shipping events":"shipping_events","Package Contents":"package_contents","Carrier":"carrier","You may also like...":"also_like","Recommended products carousel":"recommended","Previous":"previous","Next":"next"};
  const sources = new WeakMap();
  function translate(value) {
    const text = value.trim();
    let result = labels[keys[text]];
    if (!result) {
      const step = text.match(/^(Ordered|Order Ready|In Transit|Out for Delivery|Delivered) (complete|current|upcoming)$/);
      if (step) result = labels[keys[step[1]]] + ' — ' + labels[step[2]];
    }
    return result ? value.replace(text, result) : value;
  }
  function localize(owner, key, current) {
    let values = sources.get(owner);
    if (!values) { values = new Map(); sources.set(owner, values); }
    let entry = values.get(key);
    if (!entry || (current !== entry.source && current !== entry.translated)) {
      entry = {source: current, translated: translate(current)};
      values.set(key, entry);
    }
    return entry.translated;
  }
  function mount() {
    const root = document.getElementById('besttrack-tracking-page-root');
    if (!root) return false;
    let scheduled = false;
    const observer = new MutationObserver(() => {
      if (scheduled) return;
      scheduled = true;
      queueMicrotask(() => { scheduled = false; apply(); });
    });
    function apply() {
      observer.disconnect();
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        if (node.parentElement?.closest('script,style,textarea,[contenteditable="true"]')) continue;
        const next = localize(node, 'text', node.nodeValue);
        if (next !== node.nodeValue) node.nodeValue = next;
      }
      root.querySelectorAll('[aria-label],[placeholder],[title]').forEach(element => {
        ['aria-label','placeholder','title'].forEach(attribute => {
          const current = element.getAttribute(attribute);
          if (current === null) return;
          const next = localize(element, attribute, current);
          if (next !== current) element.setAttribute(attribute, next);
        });
      });
      observer.observe(root, {childList:true, subtree:true, characterData:true, attributes:true, attributeFilter:['aria-label','placeholder','title']});
    }
    apply();
    return true;
  }
  function start() {
    if (mount()) return;
    const ready = new MutationObserver(() => { if (mount()) ready.disconnect(); });
    ready.observe(document.body, {childList:true, subtree:true});
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start, {once:true});
  else start();
})();
